import { Col, Container, Table, Button, Modal, Form, Row } from 'react-bootstrap';
import SimpleBar from "simplebar-react";
import useApi from '../utilities/useApi';
import { useEffect, useState, useRef } from 'react';
import OrganisationSelector from './common/organisationSelector';
import Loading from './common/loading';
import arrayUtilities from '../utilities/arrayUtilities';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import FilterBar from './common/filterBar';
import { DataPagination } from './common/pagination';
import DeleteButton from './common/deleteButton';

export default function BluetoothConsoleLanding(props) {
    const paginationSeedNumber = 100;
    const { api } = useApi();
    const [data, setData] = useState(null);
    const [bluetoothConsole, setBluetoothConsole] = useState(null);
    const [filter, setFilter] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [organizationalUnitId, setOrganizationalUnitId] = useState(null);
    const [numberOfResultsPages, setNumberOfResultsPages] = useState(0)
    const [page, setPage] = useState(0);
    const [multiCheckedIds, setMultiCheckedIds] = useState([]);
    const [showLogModal, setShowLogModal] = useState(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = (pageNumber, searchQuery, from, to, orgUnitId) => {
        setIsLoading(true)
        api.getConsoles(
            searchQuery, from, to, orgUnitId, pageNumber,
            data => {
                if (data.isError) {
                    setData(null);
                    console.log(data.errorMessage)
                } else {
                    setData(data);
                    if (!arrayUtilities.isNullOrEmpty(data.items)) {
                        setNumberOfResultsPages(Math.ceil(data.totalCount / paginationSeedNumber))
                    }
                }
                setIsLoading(false)
            },
            error => {
                console.log(error);
                setData(null);
                setIsLoading(false)
            }
        )
    }

    useEffect(() => fetchData(0, "", null, null, null), [])

    const changeSearchFilterTimeout = useRef();
    const debouncer = (searchQuery) => {

        setFilter(searchQuery);

        if (changeSearchFilterTimeout.current) {
            clearTimeout(changeSearchFilterTimeout.current);
            changeSearchFilterTimeout.current = null;
        }

        changeSearchFilterTimeout.current = setTimeout(() => {
            setPage(0)
            fetchData(0, searchQuery, fromDate, toDate, organizationalUnitId);
        }, 1000);
    };

    const deleteConsoleLog = (id) => {
        api.deleteConsole(
            id,
            () => {
                fetchData(page, filter, fromDate, toDate, organizationalUnitId);
                setBluetoothConsole(null);
                setMultiCheckedIds([])
            },
            error => {
                console.log(error);
            }
        )
    }

    const deleteMultiConsoleLogs = () => {
        api.deleteMultipleConsoles(
            multiCheckedIds,
            () => {
                fetchData(page, filter, fromDate, toDate, organizationalUnitId);
                setBluetoothConsole(null);
                setMultiCheckedIds([])
            },
            error => {
                console.log(error);
            }
        )
    }

    const clearFilters = () => {
        setFilter("");
        setFromDate(null);
        setToDate(null);
        setOrganizationalUnitId(null);
        setPage(0);
        fetchData(0, "", null, null, null);
    }

    const handleSelectionUpdate = (e, consoleLogItem) => {
        if (e.target.checked) {
            setMultiCheckedIds(prevState => [...prevState, consoleLogItem.id])
            if (data.items.length - multiCheckedIds.length === 1) {
                setIsSelectAllChecked(true)
            }
        } else if (!e.target.checked) {
            const index = multiCheckedIds.findIndex(item => item === consoleLogItem.id)
            setMultiCheckedIds(prevState => prevState.toSpliced(index, 1))

            if (isSelectAllChecked) {
                setIsSelectAllChecked(false)
            }
        }
    }

    const handleSelectAll = (e) => {
        setIsSelectAllChecked(!isSelectAllChecked)
        if (e.target.checked) {
            setMultiCheckedIds(data.items.map(item => item.id))
        } else if (!e.target.checked) {
            setMultiCheckedIds([])
        }
    }

    return (
        <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2 report'>
            <Row>
                <Col className='mb-5'>
                    <h2 className="h2 m-0 mt-5">Bluetooth Consoles</h2>
                    <div className='d-flex align-items-center justify-content-end my-4 w-100'>
                        <Form.Group className={ `d-flex align-items-center flex-shrink-0 me-4` }>
                            <Form.Label className='text-body fs-sm me-2 mb-0 pe-1 text-nowrap'>
                                <i className='fi-calendar text-muted mt-n1'></i>
                            </Form.Label>
                            <Form.Control
                                as={ DatePicker }
                                selected={ fromDate }
                                value={ fromDate }
                                onChange={ (date) => {
                                    setFromDate(date);
                                    setPage(0)
                                    fetchData(0, filter, date, toDate, organizationalUnitId)
                                } }
                                placeholderText="Start Date"
                                dateFormat="dd/MM/yyyy"
                                className='rounded-start form-control-sm cursor-pointer'
                            />
                            <Form.Control
                                as={ DatePicker }
                                selected={ toDate }
                                value={ toDate }
                                onChange={ (date) => {
                                    setToDate(date);
                                    setPage(0);
                                    fetchData(0, filter, fromDate, date, organizationalUnitId)
                                } }
                                placeholderText="End Date"
                                dateFormat="dd/MM/yyyy"
                                className='rounded-start-0 form-control-sm cursor-pointer'
                            />
                        </Form.Group>

                        <FilterBar value={ filter } onChange={ searchQuery => debouncer(searchQuery) } className="me-4" />

                        <div>
                            <OrganisationSelector value={ organizationalUnitId } organisations={ props.organisationalUnits } onChange={ id => {
                                setOrganizationalUnitId(id);
                                setPage(0);
                                fetchData(0, filter, fromDate, toDate, id)
                            } } />
                        </div>

                        <div className='d-flex gap-2'>
                            <Button size='sm' variant='secondary' onClick={ () => clearFilters() }>
                                <span className='d-flex align-items-center'><i className='fi-refresh me-2'></i>
                                    Clear Filters
                                </span>
                            </Button>
                            <DeleteButton
                                disabled={ arrayUtilities.isNullOrEmpty(multiCheckedIds) }
                                size="sm"
                                variant="danger"
                                modalTitle="Delete multiple logs"
                                modalContent={ <>Are you sure you want to delete { multiCheckedIds.length } console logs?</> }
                                onConfirm={ () => deleteMultiConsoleLogs() }
                            />
                        </div>
                    </div>
                    {
                        isLoading
                            ? <Loading />
                            : <>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>
                                                <input name="select-all" class="form-check-input cursor-pointer" value={ isSelectAllChecked } checked={ isSelectAllChecked } type="checkbox" onChange={ e => handleSelectAll(e) } />
                                            </th>
                                            <th>Date/Time</th>
                                            <th>User Name</th>
                                            <th>Organisation</th>
                                            <th>Console Log</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !arrayUtilities.isNullOrEmpty(data?.items) && data.items
                                                .map(item => {
                                                    let outputDisplayString;
                                                    const newLineIndex = item.output.indexOf("\n")
                                                    if (newLineIndex !== -1) {
                                                        outputDisplayString = item.output.substring(0, newLineIndex)
                                                    } else {
                                                        outputDisplayString = item.output
                                                    }
                                                    return (
                                                        <tr key={ item.id }>
                                                            <td className='align-middle'>
                                                                <input
                                                                    id={ item.id }
                                                                    onChange={ e => handleSelectionUpdate(e, item) }
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={ multiCheckedIds?.includes(item.id) }
                                                                />
                                                            </td>
                                                            <td className='align-middle'>{ moment(new Date(item.timestamp)).format("DD-MM-YYYY HH:mm") }</td>
                                                            <td className='align-middle'>{ item.userName }</td>
                                                            <td className='align-middle'>{ item.organizationalUnitName }</td>
                                                            <td className='align-middle'>
                                                                <div className='table-truncated'>{ outputDisplayString }</div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex gap-2 justify-content-end'>
                                                                    <Button variant='primary' size="sm" onClick={ () => {
                                                                        setBluetoothConsole(item);
                                                                        setShowLogModal(true);
                                                                    } }>
                                                                        <span className='d-flex align-items-center'><i className='fi-eye-on m-0 me-2'></i>View Full Log</span>
                                                                    </Button>
                                                                    <DeleteButton
                                                                        size="sm"
                                                                        variant="outline-danger"
                                                                        modalTitle="Delete log"
                                                                        modalContent={ <>Are you sure you want to delete this console log?</> }
                                                                        onConfirm={ () => deleteConsoleLog(item.id) }
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                )
                                        }
                                    </tbody>
                                </Table>
                                {
                                    !arrayUtilities.isNullOrEmpty(data?.items)
                                    && <div className='d-flex justify-content-center'>
                                        <DataPagination
                                            totalResults={ data?.totalCount }
                                            page={ page }
                                            onPageNumberClick={ pageNumber => {
                                                setPage(pageNumber)
                                                fetchData(pageNumber, filter, fromDate, toDate, organizationalUnitId)
                                            } }
                                            paginationSeedNumber={ paginationSeedNumber }
                                            numberOfResultsPages={ numberOfResultsPages }
                                        />
                                    </div>
                                }
                            </>
                    }
                </Col>
            </Row>

            {
                <Modal size='lg' show={ showLogModal } onHide={ () => setShowLogModal(false) } centered>
                    <Modal.Body>
                    <SimpleBar autoHide={ false } className='simplebar-no-autohide pe-3 modal-scroll'>
                        <div className='bg-black p-2 rounded'>
                            <code className='text-white'>
                                { bluetoothConsole?.output.split("\n").map(item => <span>{item}<br /></span>) }
                            </code>
                        </div>
                    </SimpleBar>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setShowLogModal(false) }>Close</Button>
                    </Modal.Footer>
                </Modal>
            }
        </Container>
    )
}